<template>
  <div class="widget">
    <div class="widget-heading align-items-center py-3" v-if="title && !isSkillConfigRoute()">
      <h2 v-if="title" class="textStyle d-flex">
        <button v-if="!hideBackButton" class="btn-icon me-2" v-tooltip="{ title: $t('back') }" @click="$router.back()">
          <FontAwesomeIcon icon="fa-light fa-arrow-left" />
        </button>
        <span>
          {{ title }}
        </span>
      </h2>
      <button v-if="resetBtn" class="btn btn-success" v-tooltip="{ title: $t('init_search') }" @click="formReset">
        <FontAwesomeIcon icon="fa-light fa-arrows-rotate" />
      </button>
      <router-link
        v-if="routerButton && routerButton.params && routerButton.route && routerButton.icon"
        :to="{
          name: routerButton.route,
          params: { [routerButton.paramsIndex ? routerButton.paramsIndex : 'params']: routerButton.params },
        }"
        class="btn btn-icon"
        v-tooltip="{ title: routerButton.tooltip }"
      >
        <FontAwesomeIcon :icon="'fa-light fa-' + routerButton.icon" />
      </router-link>
    </div>
    <div v-if="models && Object.keys(models).length" class="widget-content">
      <slot name="infos"></slot>
      <FormComponent
        :models="models"
        :hideSubmit="hideSubmit"
        :justifyRowEnd="justifyRowEnd"
        @formCancel="formCancel"
        @formSubmit="formSubmit"
        @update="update"
        @toggle="toggle"
        @selectTypeAction="selectTypeAction"
      />
    </div>
    <BlockLoader :loading="loading" />
  </div>
</template>

<script>
import FormComponent from "@/components/FormComponent.vue";
import BlockLoader from "@/components/blocks/BlockLoader.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  name: "FormBlockComponent",
  components: { FontAwesomeIcon, BlockLoader, FormComponent },
  props: {
    models: {
      type: [Array, Object],
      required: true,
    },
    title: {
      type: String,
      required: false,
      default: "",
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    hideSubmit: {
      type: Boolean,
      required: false,
      default: false,
    },
    resetBtn: {
      type: Boolean,
      required: false,
      default: false,
    },
    hideBackButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    routerButton: {
      /** @type {import('vue').PropType<RouterButton>} */
      type: Object,
      required: false,
      default: () => ({}),
    },
    justifyRowEnd: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ["update", "toggle", "submit", "formCancel", "formReset", "selectTypeAction"],
  methods: {
    formSubmit(payload) {
      this.$emit("submit", payload);
    },
    update() {
      this.$emit("update");
    },
    toggle() {
      this.$emit("toggle");
    },
    formCancel() {
      this.$emit("formCancel");
    },
    formReset() {
      this.$emit("formReset");
    },
    isSkillConfigRoute() {
      return (
        this.$route.name === "adminModuleSkillConfiguration" || this.$route.name === "studeaManagerSkillConfiguration"
      );
    },
    selectTypeAction(payload) {
      this.$emit("selectTypeAction", payload);
    },
  },
};
</script>

<style lang="scss" scoped>
.widget {
  min-height: 400px;
}
</style>
